$('body').on('click','.previo-list-reservation button, .previo-detail-reservation button, .previo-package-reservation button',function() {
    $.ajax({
        type: 'GET',
        url: '/ajax/',
        dataType: "json",
        data: {
            "f":"94a82b3c7122b1d74421c332f3c77c66",
            "pid": $(this).data('previo-id'),
            "spid": $(this).data('previo-stay-package'),
            "from": $(this).data('from'),
            "to": $(this).data('to')
        },
        success: function(data){
            if(data.status) {
                if(data.status) {
                    $('body').append(data.popup);
                    $('#previo-iframe-popup').modal('show');
                    $('#previo-iframe-popup').on('hidden.bs.modal', function (e) {
                        $(this).remove();
                    });
                }
            }
        }
    });
    return false;
});